import React from "react"
import Slider from "react-slick"
import Igm from "../../../../styles/medias/images/actualite.png"
import Moment from 'react-moment';
const CarousselNews = ({news}) => {

    const news1 = news && [...news];
    const settings = {
        centerMode: true,
        centerPadding: '60px',
        slidesToShow: 3 ,
        arrows: true,
        dots: false ,
        className: "liste-actu"
      }
    return(
    
    <Slider {...settings} > 
           {
                news1 && news1.map((res, index) => {
                   return (
                    <div className="list" key={index}>
                        <div className="image">
                        <img src={res.image && `${process.env.GATSBY_API_URL}`+res.image.url} alt={res.name}/>
                        </div>
                        <div className="content">
                            <span className="tag">{res.tags}</span>
                            <h3>{res.description}</h3>
                            <Moment locale="fr" className="date" format="D MMMM YYYY" date={res.created_at} />
                            <p>
                                <a href="#" className="lireplus">Lire plus</a>
                            </p>
                        </div>
                    </div>
                   )
               })
           }
    </Slider>
    )
}
export default CarousselNews;